export default "__VITE_ASSET__zGGjScwC__"